import getConfig from 'next/config';
import React, { memo } from 'react';

import { Typography } from '@sravni/react-design-system';
import { SpecialOffers } from '@sravni/react-ugc/lib/SpecialOffers';
import { SpecialOffersForInsurance } from '@sravni/react-ugc/lib/SpecialOffersForInsurance';
import { useAnalytics, useIsMobile } from '@sravni/react-utils';
import { hasItem, makeTab } from '@sravni/ugc/lib/specialOffers/helpers';
import { ACTIONS } from '@sravni/ugc/lib/specialOffers/lists';
import { Tab } from '@sravni/ugc/lib/specialOffers/types';

import { AB_NAME } from '../../pages/_app';

const { specialOffersUrl } = getConfig().publicRuntimeConfig;

export const SpecialOffersBlock = memo<{ tabs: Tab[] }>(({ tabs }) => {
  const isMobile = useIsMobile();
  const { pushEvent } = useAnalytics();

  if (!tabs.length) return null;

  const isLoadRecentActions = hasItem(tabs, makeTab(ACTIONS.osago));

  const props = {
    className: 'h-mt-32',
    heading: <Typography.Heading level={4} as={'h2'} className={isMobile ? 'h-mb-12' : 'h-mb-28'} />,
    headingType: 'popover' as 'popover',
    pushEvent,
    abName: AB_NAME,
    isNarrowOnDesktop: true,
    iframeSrc: specialOffersUrl,
  };

  if (isLoadRecentActions) {
    return <SpecialOffersForInsurance {...props} />;
  }

  return <SpecialOffers {...props} tabs={tabs} />;
});
